export const START = '[App] Start'
export type START = typeof START
export interface Start {
  type: START
}
export const start = (): Start => ({ type: START })
export type StartAction = Start



// WEBPACK FOOTER //
// ./src/app.actions.ts